import React, { useState, useEffect } from 'react';
import "./contact.css";
// import Sidebar from '../../Components/Sidebar/Sidebar';
import HNavbar from '../../Components/Navbar/HNavbar';
import MFooter from '../../Components/Main-Footer/MFooter';
import SEO from '../../Components/SEO';

function Contact() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        console.log({
            name,
            mail,
            phone,
            message
        });

        window.location.href = mailtoLink;

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    return (
        <>
            <SEO
                title="Noise Barrier Supplier & Acoustic Barrier"
                description="Contact a trusted noise barrier supplier for acoustic barriers, soundproof fencing and customized noise control solutions for industrial projects."
                canonical="https://www.soundbarrier.in/contactus"
            />
            <HNavbar />
            {/* ===== HERO ===== */}
            <section className="sb-hero">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-xl-5">
                            <h1 className="hero-title">
                                <span className="orange">QUOTES & CONTACTS
                                </span><br />
                            </h1>
                            <p className="hero-desc">
                                Need privacy from noisy neighbours?<br />
                                <br />
                                Contact us today!
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section id='contact' className='home'>
                <Sidebar />
                <div className='container p-0'>
                    <div className='row'>
                        <div className='col-12 text-center d-flex flex-column justify-content-center align-items-start' style={{ color: "white" }}>
                            <h1>QUOTES & CONTACTS</h1>
                            <p>Need privacy from noisy neighbours?</p>
                            <p>Contact us today!</p>
                        </div>
                    </div>
                </div>
            </section> */}
            <section id='contact' style={{ marginBottom: "20px" }}>
                <div className='container'>
                    <div className='row mt-4 align-items-center' style={{ minHeight: "200px" }}>
                        <div className='col-sm-12 col-md-6 d-flex justify-content-center align-items-center text-start'>
                            <div>
                                <p className='contact-add'>
                                    Acoustical Surfaces Industries LLP.<br />
                                    130/2B, Morappampalayam,<br />
                                    Uppilipalayam (P.O), Karuvalur<br />
                                    Tirupur - 641670<br />
                                    Tamil Nadu, India
                                </p>

                                <div className="mb-2">
                                    <i className="bx bx-phone-call nav-icon-contact"></i>
                                    <b className='tel'> Tel:</b>{" "}
                                    <a className='num' href="tel:+919449777212">+91-9449777212</a> |{" "}
                                    <a className='num' href="tel:+918277331000">+91-82773 31000</a>
                                </div>

                                <div>
                                    <i className="bx bx-envelope nav-icon-contact"></i>
                                    <a
                                        className='mail'
                                        href="mailto:mail@acousticalsurfaces.in?subject=Inquiry&body=Hello, I would like to know more about your services."
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        mail@acousticalsurfaces.in
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 mt-2'>
                            <div className='form'>
                                <div className="row">
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="text"
                                            name="name"
                                            id="name"
                                            className="form-control"
                                            placeholder="Name *"
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="email"
                                            name="mail"
                                            id="mail"
                                            className="form-control"
                                            placeholder="Email *"
                                        />
                                    </div>
                                    <div className="col-sm-12 col-md-4 mb-3">
                                        <input
                                            type="text"
                                            name="phone"
                                            id="phone"
                                            className="form-control"
                                            placeholder="Phone *"
                                        />
                                    </div>
                                    <div className="col-12 mb-3">
                                        <textarea
                                            rows={4}
                                            id="message"
                                            className="form-control"
                                            placeholder="Message *"
                                        ></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button
                                            className="btn"
                                            type="button"
                                            onClick={handleClick}
                                        >
                                            SEND
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )}
            <MFooter />
        </>
    )
}

export default Contact